export const environment = {
  production: true,
  baseURL: 'https://www.sehyog.co.uk/services/',
  frontBaseURL: 'https://www.sehyog.co.uk/',
  // baseURL: 'https://staging.sehyog.co.uk/services/',
  // frontBaseURL: 'https://staging.sehyog.co.uk/',
  liveGoogleCaptcha: '6LfP6KcUAAAAAAUlIn5zohaCJBSYir2ZPhoRrXz3',
  vendorDashboardURL: 'https://onlineexam.sehyog.co.uk/CBT2393/UserLogin.aspx?ClientID=239300', // changing as per vendor asked on 10-08-24 https://onlinetestforum.com/ECAS/UserLogin.aspx
  openAiKey: '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'
};

